export const environment = {
  production: true,
  baseURL: 'https://www.sehyog.co.uk/services/',
  frontBaseURL: 'https://www.sehyog.co.uk/',
  // baseURL: 'https://staging.sehyog.co.uk/services/',
  // frontBaseURL: 'https://staging.sehyog.co.uk/',
  liveGoogleCaptcha: '6LfP6KcUAAAAAAUlIn5zohaCJBSYir2ZPhoRrXz3',
  vendorDashboardURL: 'https://onlineexam.sehyog.co.uk/CBT2393/UserLogin.aspx?ClientID=239300', // changing as per vendor asked on 10-08-24 https://onlinetestforum.com/ECAS/UserLogin.aspx
  openAiKey: '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'
};

